import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getAllZeeDocuments } from '@/actions/zee-document/getAllZeeDocuments';
import { ApiResponse } from '@/types/response.type';
import { ZeeDocument } from '@/types/zee.document.type';

export interface UseGetAllZeeDocumentsReturn {
  result: ApiResponse<Array<ZeeDocument>> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetAllZeeDocuments = (): UseGetAllZeeDocumentsReturn => {
  const query: UseQueryResult<
    ApiResponse<Array<ZeeDocument>> | undefined,
    Error
  > = useQuery({
    queryKey: ['zee-documents'],
    queryFn: getAllZeeDocuments,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
